<template>
    <div v-if="showCampLine" class="floatingBtn">
        <a
            :href="$store.state.campLineUrl"
            target="_blank"
            rel="noopener"
            class="camp-line-link btn btn-primary shadow-sm"
            aria-label="開啟 LINE 營隊詢問（另開新視窗）"
        >
            <img class="camp-line-icon" src="@/assets/svg/line.svg" alt="">
            <p class="camp-line-label mb-0 mt-1 font-weight-bolder text-center">
                營隊詢問
            </p>
        </a>
    </div>
</template>

<script>
import { CAMP_ROUTE_NAMES } from '@/utils/campRouteNames';

export default {
    name: 'CampFloatingBtn',
    computed: {
        showCampLine() {
            return !!this.$store.state.campLineUrl && CAMP_ROUTE_NAMES.includes(this.$route.name);
        },
    },
};
</script>

<style lang="scss" scoped>
.floatingBtn {
    position: fixed;
    top: 450px;
    right: 0;
    z-index: 1030;

    p {
        font-size: 12px;
        letter-spacing: 1px;
    }
}

@media (max-width: 767.98px) {
    .floatingBtn {
        top: 65%;
        transform: translateY(-50%);

        .camp-line-link {
            display: flex;
            width: 44px;
            min-height: 96px;
            padding: 8px 0;
            align-items: center;
            justify-content: center;
            border-radius: 8px 0 0 8px;
        }

        .camp-line-icon {
            display: none;
        }

        .camp-line-label {
            margin-top: 0 !important;
            font-size: 15px;
            line-height: 1.35;
            letter-spacing: 2px;
            writing-mode: vertical-rl;
            text-orientation: upright;
        }
    }
}
</style>
